export interface MediaInAnimationComposition {
	property: string;
	from: number;
	to: number;
	durationInFrames: number;
	delay?: number;
	ease: (input: number) => number;
	easing: string;
	previewUrl: string;
	name: string;
}

export interface MediaInAnimationPreset {
	name: string;
	composition: MediaInAnimationComposition[];
}

function linearEase(input: number): number {
	return input;
}

function smoothEase(input: number): number {
	return input * input * (3 - 2 * input);
}

/**
 * Shared media-safe in-animation presets used across editor/runtime mapping.
 */
export const mediaInAnimationPresets: Record<string, MediaInAnimationPreset> = {
	fadeIn: {
		name: "fadeIn",
		composition: [
			{
				property: "opacity",
				from: 0,
				to: 1,
				durationInFrames: 15,
				ease: linearEase,
				easing: "linear",
				previewUrl: "https://cdn.designcombo.dev/animations/FadeIn.webp",
				name: "Fade",
			},
		],
	},
	scaleIn: {
		name: "scaleIn",
		composition: [
			{
				property: "scale",
				from: 0,
				to: 1,
				durationInFrames: 15,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/ScaleIn.webp",
				name: "Scale",
			},
		],
	},
	kenBurnsIn: {
		name: "kenBurnsIn",
		// Catalog / picker preview only. Runtime compositions come from
		// manageKenBurnsEffect() (dynamic zoom in/out + pan).
		composition: [
			{
				property: "scale",
				from: 1,
				to: 1.08,
				durationInFrames: 90,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/ScaleIn.webp",
				name: "Ken Burns",
			},
		],
	},
	slideInRight: {
		name: "slideInRight",
		composition: [
			{
				property: "translateX",
				from: -900,
				to: 0,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideInRight.webp",
				name: "Slide Right",
			},
		],
	},
	slideInLeft: {
		name: "slideInLeft",
		composition: [
			{
				property: "translateX",
				from: 900,
				to: 0,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideInLeft.webp",
				name: "Slide Left",
			},
		],
	},
	slideInTop: {
		name: "slideInTop",
		composition: [
			{
				property: "translateY",
				from: 900,
				to: 0,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideInTop.webp",
				name: "Slide Top",
			},
		],
	},
	slideInBottom: {
		name: "slideInBottom",
		composition: [
			{
				property: "translateY",
				from: -900,
				to: 0,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideInBottom.webp",
				name: "Slide Bottom",
			},
		],
	},
};

export const mediaInAnimationPresetList = Object.values(mediaInAnimationPresets);
